var revision=require("./revision");
var intertext=require("./intertext");
module.exports={"rev":revision,intertext:intertext};